import ReactDOM from 'react-dom';
import React, { Component } from 'react';
import Star from '../components/Star';
import ParameterErrors from '../errors/ParameterErrors';
import IconButtonNonReact from '../components/IconButtonNonReact';
import PlotStatus from '../site/PlotStatus';
import AssetsManager from '../assets_management/AssetsManager';
import Urls from '../urls/Urls';
import UrlHelper from '../core/UrlHelper';
import ResizeWatcher from '../ui_core/ResizeWatcher';
import PropertyBindingFactory from '../mvvm/PropertyBindingFactory';
import FullScreen from '../ui_core/FullScreen';
import PlotDetailedInformationSectionType from './PlotDetailedInformationSectionType';
import eventEnable from '../core/eventEnable';
const {throwNotProvided}=ParameterErrors;
export default class PlotDetailedInformationTour {
	constructor(props){
		const { siteJsonUnitPlot, configuration}=props;
		eventEnable(this);
		this._setVisible = this._setVisible.bind(this);
		this._siteJsonUnitPlot = siteJsonUnitPlot;
		this._configuration = configuration;
		this._houseType = siteJsonUnitPlot.houseType;
		if(!this._houseType)return;
		this._element = document.createElement('div');
		this._element.classList.add('tour');
		this._iframeElement = document.createElement('iframe');
		this._dispatchLoaded = this._dispatchLoaded.bind(this);
		this._iframeElement.addEventListener('load', this._dispatchLoaded);
		this._tourOrConfiguratorUrlChanged = this._tourOrConfiguratorUrlChanged.bind(this);
		this._handleClickButtonFullscreen = this._handleClickButtonFullscreen.bind(this);
		this._element.appendChild(this._iframeElement);
		this._configuratorUrl = Urls.getConfiguratorUrlForPlot(this._siteJsonUnitPlot, this._configuration);
		this._propertyBindingTourUrl = PropertyBindingFactory.standard(this, this._houseType, 'tourUrl', this._tourOrConfiguratorUrlChanged);
		this._propertyBindingConfiguratorUrl = PropertyBindingFactory.standard(this, this._houseType, 'configuratorUrl', this._tourOrConfiguratorUrlChanged);
		this._iconButtonFullScreen = new IconButtonNonReact({
			className:"button-fullscreen",
			imgUrl:Urls.assets+'icons/UI_Fullscreen.png',
			onClick:this._handleClickButtonFullscreen});
		this._element.appendChild(this._iconButtonFullScreen.element);
	}
	_handleClickButtonFullscreen(){
		
		FullScreen.toggle(this._element);
	}
	_tourOrConfiguratorUrlChanged(value){
		this._configuratorUrl = Urls.getConfiguratorUrlForPlot(this._siteJsonUnitPlot, this._configuration);
		if(!this._configuratorUrl){
			this._setVisible(false);
			return;
		}
		this._setVisible(true);
		this._iframeElement.src = this._configuratorUrl;
	}
	_setVisible(value){
		if(value)this._element.classList.add('visible');
		else this._element.classList.remove('visible');
	}
	get element(){
		return this._element;
	}
	get sectionType(){
		return PlotDetailedInformationSectionType.Tour;
	}
	_dispatchLoaded(){
		this.dispatchEvent({type:'loaded'});
	}
}